import React, { FunctionComponent, useState } from 'react'
import { Spin, Modal } from 'antd'

type TProps = {
	link: string
	onClose: () => void
}

const WithdrawModal: FunctionComponent<TProps> = ({ link, onClose }) => {
	const [loading, setLoading] = useState<boolean>(true)
	return (
		<Modal width={700} visible={true} footer={null} title="Withdraw Money" onCancel={onClose}>
			{loading && (
				<div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
					<Spin size="large" />
				</div>
			)}

			<iframe style={{ border: 'none' }} src={link} height={500} width={650} onLoad={() => setLoading(false)} />
		</Modal>
	)
}

export default WithdrawModal
